import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { TIRES_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class TiresService {
  static getTires = async data => {
    try {
      const response = await HTTPHandler.post(
        TIRES_API_URL + '/tireSet/list',
        data
      )

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }
}
